__turbopack_context__.v({
  "all-input-design-alignment": "timeConvertForm-module__M7p0Ya__all-input-design-alignment",
  "card": "timeConvertForm-module__M7p0Ya__card",
  "instruction": "timeConvertForm-module__M7p0Ya__instruction",
  "label": "timeConvertForm-module__M7p0Ya__label",
  "searchWrap": "timeConvertForm-module__M7p0Ya__searchWrap",
  "timeDisplay": "timeConvertForm-module__M7p0Ya__timeDisplay",
  "timezoneName": "timeConvertForm-module__M7p0Ya__timezoneName",
  "wrapper": "timeConvertForm-module__M7p0Ya__wrapper",
});
